export class ChangeTypeConstants {
    static All = 'All Work Orders';
    static ReservePower = 'Reserved Powers';
    // static Closures = 'Closures';
    static WorkOrders = 'Non-Reserved Powers';
}
